import { CommonHttpOption } from "./../../base/common-http-option";
import { ServiceRoute } from "./../../base/service-route";
import { Injectable } from "@angular/core";
import { CoreService } from "../../base/core";
import { Observable } from "rxjs";
import { IParentTerm } from "src/app/interfaces/parent-term";
import { IActivePattern } from "src/app/interfaces/activePattern";
import { HttpHeaders } from "@angular/common/http";

@Injectable({
  providedIn: "root"
})
export class ParrentTermService {
  constructor(private coreService: CoreService) { }

  list(page = 1, pageSize = 10): Observable<any> {
    return this.coreService.get(
      ServiceRoute.parrentTerm.list,
      new CommonHttpOption().headers,
      new CommonHttpOption().paginator(page, pageSize)
    );
  }

  listComboByYear(year: number): Observable<any> {
    return this.coreService.get(
      ServiceRoute.parrentTerm.listComboByYear + year,
      new CommonHttpOption().headers
    );
  }

  listByCompanyHeader(page = 1, pageSize = 10, header: HttpHeaders): Observable<any> {
    return this.coreService.get(
      ServiceRoute.parrentTerm.list,
      header,
      new CommonHttpOption().paginator(page, pageSize)
    );
  }

  getById(id: number): Observable<any> {
    return this.coreService.get(
      ServiceRoute.termInfo.getById + id,
      new CommonHttpOption().headers
    );
  }

  add(data: IParentTerm): Observable<any> {
    return this.coreService.post(
      ServiceRoute.parrentTerm.add,
      data,
      new CommonHttpOption().headers
    );
  }

  edit(data: IParentTerm): Observable<any> {
    return this.coreService.put(
      ServiceRoute.parrentTerm.edit,
      data,
      new CommonHttpOption().headers
    );
  }

  active(data: IActivePattern): Observable<any> {
    return this.coreService.put(
      ServiceRoute.parrentTerm.ActiveDeActive,
      data,
      new CommonHttpOption().headers
    );
  }
}
